import * as yup from 'yup';

import { DictionaryIndex, themeObject, validationsMessages } from 'lib';
import { regExIdentifiers, validationMessages } from 'constants/validations';
import {
    HexIndexNormal,
    HexIndexPrimary,
    HexIndexText,
    HexIndexUnique,
    HexIndexVector,
} from '../../../../assets';
import { CSSProperties } from 'react';

export const attributeErrorMessage = 'Please select one or more attributes';

export type TypeData = {
    type: string;
    typeLabel: string;
    typeIcon: string;
    typeIconStyles?: CSSProperties;
};

export const typesData: TypeData[] = [
    {
        type: 'PRIMARY',
        typeLabel: 'Primary',
        typeIcon: HexIndexPrimary,
        typeIconStyles: {
            width: '22.71px',
            height: '24px',
        },
    },
    {
        type: 'NORMAL',
        typeLabel: 'Normal',
        typeIcon: HexIndexNormal,
        typeIconStyles: {
            width: '22.71px',
            height: '24px',
        },
    },
    {
        type: 'UNIQUE',
        typeLabel: 'Unique',
        typeIcon: HexIndexUnique,
        typeIconStyles: {
            width: '22.71px',
            height: '24px',
        },
    },
    {
        type: 'KEYWORD',
        typeLabel: 'Search Keyword',
        typeIcon: HexIndexText,
        typeIconStyles: {
            width: '22.71px',
            height: '24px',
        },
    },
    {
        type: 'VECTOR',
        typeLabel: 'Vector',
        typeIcon: HexIndexVector,
        typeIconStyles: {
            width: '22.71px',
            height: '24px',
        },
    },
];

export const indexesStyles = {
    drawer: {
        '& .MuiPaper-root': {
            width: '360px',
            '& .drawer-content': {
                padding: 0,
                height: '100%',
            },
            '& .drawer-footer': {
                mt: 0,
                p: '16px 45px 16px 33px',
            },
        },
    },
    iconButtonContainerStyles: {
        display: 'flex',
        justifyContent: 'end',
        mt: 2,
    },
    titleStyles: {
        ...themeObject.typography.h3,
        lineHeight: '28.18px',
        color: themeObject.palette.primary[700],
    },
    formContainerStyles: {
        mt: '1px',
    },
    nameFieldStyles: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    fieldStyles: {
        mt: 2,
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    menuOptionContainerStyles: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    selectOptionTextStyles: {
        ...themeObject.typography.Components.inputText,
        lineHeight: '24px',
        color: themeObject.palette.grayScale[800],
    },
    searchIconStyles: {
        color: `${themeObject.palette.primary[400]} !important`,
        width: '24px !important',
        height: '24px !important',
    },
    crossIconStyles: {
        cursor: 'pointer',
        '& .MuiSvgIcon-root': {
            height: '14px',
            width: '14px',
            color: themeObject.palette.grayScale.A200,
        },
    },
    buttonContainerStyles: {
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
    },
};

export const indexSchema: yup.SchemaOf<DictionaryIndex> = yup.object({
    id: yup.string().optional(),
    name: yup
        .string()
        .required(validationsMessages.required)
        .matches(regExIdentifiers.name, validationMessages.invalidName),
    type: yup.string().required(validationsMessages.required),
    attributes: yup.array().optional(),
    partialFilterTql: yup.string().optional(),
});
